// src/encounter/intelligence/sent-asks.ts
//
// The free Ask presses already sent this page session (Codex on #959). Leaving a tab unmounts the rail's Ask card; when it
// mounts again with the same press it must not run the model a second time. Each Send takes a press number from
// nextAskSeq(), unique for the page session, so a new Send (also after the encounter page is reopened) is never mistaken
// for one already sent. Keyed by patient, press and question; it never holds an answer.
const SENT = new Set<string>();
let lastSeq = 0;

export const nextAskSeq = () => ++lastSeq;
export const askKeyOf = (patientId: string, seq: number, question: string) => `${patientId}|${seq}|${question}`;
export const wasAskSent = (key: string) => SENT.has(key);
export const markAskSent = (key: string) => void SENT.add(key);
/** Test seam: each test starts with no question sent. */
export const resetSentAsksForTests = () => SENT.clear();
